import cec from '@/module/interactionCenter/page/cec/manage.vue'
import layout from '@/layout/index'
// 导出配置的路由器
export default [{
  path: '/interactionCenter',
  component: layout,
  redirect: 'interactionCenter/cec',
  meta: {
    title: '交互中心',
    icon: 'icon-jiaohu',
    perms:['bee:ict']
  },
  children: [
    {
      path: 'cec',
      component: cec,
      meta: {icon: 'icon-duijie1', title: '中电联标准对接', perms:['bee:ict:cecCompanyInfo']}
    },
    {
      path: 'secretKey',
      component: () => import("@/module/interactionCenter/page/companySecretKeyManager.vue"),
      meta: {icon: 'icon-duijie1', title: '停车系统对接',perms:['bee:res:secretKey']}
    },
    //{
    //  path: 'dupower',
    //  component: winline,
    //  meta: {icon: 'icon-duijie',title: '度普标准对接'}
    //}
  ]
}]



// WEBPACK FOOTER //
// ./src/module/interactionCenter/router/index.js